import "../css/checkout.css";

const form = document.querySelector(
  "form.wc-block-components-form, form.checkout, .wc-block-checkout",
);
const buttons = document.querySelectorAll(
  ".wc-block-components-checkout-place-order-button, #place_order",
);

const markProcessing = () => {
  document.body.classList.add("nanzora-checkout-processing");
  buttons.forEach((button) => {
    button.setAttribute("aria-disabled", "true");
    button.setAttribute("aria-busy", "true");
    if ("disabled" in button) {
      button.disabled = true;
    }
  });
};

buttons.forEach((button) => {
  button.addEventListener("click", () => {
    window.setTimeout(markProcessing, 0);
  });
});

form?.addEventListener("submit", markProcessing);

window.nanzoraEmit?.("begin_checkout");
